import {defineStore} from 'pinia';
import {ModuleJusticeDecisionGroup} from '../moduleConst';
import justiceDecisionGroupAPI from '@/apis/di/justiceDecisionGroupAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
const justiceDecisionGroupStore = new BaseDictionaryStore(justiceDecisionGroupAPI);
export const useJusticeDecisionGroupStore = defineStore(ModuleJusticeDecisionGroup, {
  state: () => ({
    ...justiceDecisionGroupStore.state,
    _config: {
      key: 'justice_decision_group_id',
      code: 'justice_decision_group_alias',
      name: 'justice_decision_group_name',
      table: 'di_justice_decision_group',
      quickFollow: 'active',
      moduleName: 'Nhóm quyết định',
      defaultSort: 'justice_decision_group_alias',
    },
    moduleName: 'diJusticeDecisionGroup',
  }),
  actions: {...justiceDecisionGroupStore.action},
  getters: {
    ...justiceDecisionGroupStore.getters,
  },
});
